import {IStateService} from "angular-ui-router";

require('./table.less');


class TableController {
    query = {
        limit: 100,
        limitOptions: [20, 50, 100, 200],
        page: 1,
        order: ''
    };
    filter = {
        filterText: "",
        active: false
    };
    tableDefinition;
    tableContent;
    tableTitle;
    columns;
    settings;
    initiated;
    queryListener;
    activeState;
    urlListener;
    minimized = false;

    constructor(private $state: IStateService, private $scope, private $location: ILocationService, private $filter) {
        $scope.query = this.query;
        this.urlListener = $scope.$on('$locationChangeSuccess', () => {
            this.setPaginationSettings()
        });
    }

    $onInit() {
        this.activeState = angular.copy(this.$state.current.name);
        this.settings = this.tableDefinition.settings;
        this.columns = this.tableDefinition.columns;
        if (this.settings.limitOptions) {
            this.query.limitOptions = this.settings.limitOptions;
        }
        this.setPaginationSettings();
        if (this.settings.filterAutoFocus) {
            this.filter.active = true;
            this.setFocus();
        }

        if (this.settings.minimizable) {
            this.minimized = this.settings.minimizedOnInit == true;
        }

        this.queryListener = this.$scope.$watchCollection('query', (query) => {
            if (this.initiated && this.tableContent && this.settings.onPaginate && this.activeState === this.$state.current.name) {
                this.settings.onPaginate(query.page, query.limit);
            }
            this.initiated = true;
        });
    }

    $onDestroy() {
        this.urlListener();
        this.queryListener();
    }

    setPaginationSettings() {
        const queryParams = this.$location.search();
        this.query.limit = queryParams.pageSize ? parseInt(queryParams.pageSize) : this.settings && this.settings.initialPageSize ? this.settings.initialPageSize : 100;
        this.query.order = this.settings && this.settings.initialOrderBy ? this.settings.initialOrderBy : '';
        this.query.page = queryParams.pageNo ? parseInt(queryParams.pageNo) + 1 : 1;
    }


    callRowFunction($event, item) {
        if (!!this.settings.editFunction) {
            this.settings.editFunction($event, item)
        }
    }

    setFocus() {
        // Necessary for autofocusing this particular field. No better solution was found
        $("#tableFilter").focus();
    }

    onKeyCombinationFilter(e) {
        if (e.key === 'S' && e.ctrlKey && e.shiftKey) {
            this.filter.active = !this.filter.active;
            this.filter.filterText = "";
        }
    }

    updateDataFunction() {
        if (!!this.settings.updateFunction) {
            this.settings.updateFunction()
        }
    }

    backFunction() {
        if (!!this.settings.backFunction) {
            this.settings.backFunction()
        }
    }

    setFilterState(s) {
        this.filter.filterText = "";
        this.filter.active = s;
    }
}

class TableOptions implements ng.IComponentOptions {
    bindings: any = {
        tableContent: '=',
        tableDefinition: '=',
        tableTitle: '='
    };
    controller: string = 'ccTableController';
    controllerAs: string = 'c';
    template: any = require('./table.html');
}

rkcApp.controller("ccTableController", ['$state', '$scope', '$location', '$filter', function ($state, $scope, $location, $filter) {
    return new TableController($state, $scope, $location, $filter);
}])
    .component("rkcTable", new TableOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/table/table.ts
 **/